// import { useEffect, useRef, useState } from "react";
// import {
//   Button,
//   DatePicker,
//   Flex,
//   Input,
//   message,
//   Spin,
//   Table,
//   Tag,
//   TreeSelect,
//   Modal,
// } from "antd";
// import {
//   DeleteOutlined,
//   EditOutlined,
//   FolderOpenOutlined,
//   HistoryOutlined,
// } from "@ant-design/icons";
// import { fetchBuilders, deleteBuilder } from "../Service/checklistBuilder";
// import { useNavigate } from "react-router-dom";
// import dayjs from "dayjs";
// import { fetchProduct } from "../../../../../configuration/module/Product/Service/product";
// import { buildTreeData } from "../../../../../configuration/module/Product/Component/product";
// import usePermission from "../../../../../hooks/usePermission";
// import api from "../../../../../BasicComponent/Service/api";
// import { CHECKLIST_BUILDER_URL } from "../../../../utils/constService";

// const { RangePicker } = DatePicker;

// // ── Revision badge ─────────────────────────────────────────────────────────
// const RevisionBadge = ({ revisionNo }) => (
//   <Tag
//     icon={<HistoryOutlined />}
//     color={revisionNo > 1 ? "orange" : "default"}
//     style={{ fontSize: 10, padding: "0 5px", marginLeft: 4 }}
//   >
//     Rev {revisionNo}
//   </Tag>
// );

// const ChecklistBuilder = () => {
//   const { canCreate, canUpdate, canDelete } = usePermission("CHECKLIST_TEMPLATE");
//   const navigate = useNavigate();

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(50);
//   const [total, setTotal] = useState(0);
//   const [search, setSearch] = useState("");
//   const [productList, setProductList] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [dateRange, setDateRange] = useState([]);
//   const [sortField, setSortField] = useState("createdDate");
//   const [sortOrder, setSortOrder] = useState("descend");
//   const searchTimer = useRef(null);

//   const fetchData = async (pageNum = page, pageSize = size, filters = {}) => {
//     setLoading(true);
//     try {
//       const res = await fetchBuilders({
//         page: pageNum - 1,
//         size: pageSize,
//         search: (filters.search ?? search) || undefined,
//         productId: filters.productId ?? selectedProduct ?? undefined,
//         fromDate: filters.fromDate ?? (dateRange?.length === 2 ? dateRange[0] : undefined),
//         toDate: filters.toDate ?? (dateRange?.length === 2 ? dateRange[1] : undefined),
//         sort: filters.sort ?? sortField,
//         desc: filters.desc ?? sortOrder === "descend",
//       });
//       setData(res.data?.content || []);
//       setTotal(res.data?.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//     } catch {
//       message.error("Network error while fetching builders");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getProductList = async () => {
//     try {
//       const res = await fetchProduct();
//       setProductList(buildTreeData(res.data));
//     } catch {
//       message.error("Network error while fetching products");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     getProductList();
//   }, []);

//   useEffect(() => {
//     if (searchTimer.current) clearTimeout(searchTimer.current);
//     searchTimer.current = setTimeout(() => fetchData(1, size), 500);
//     return () => clearTimeout(searchTimer.current);
//   }, [search]);

//   // ── Delete with execution guard ──────────────────────────────────────────
//   const deleteData = async (uuid) => {
//     try {
//       await deleteBuilder(uuid);
//       message.success("Checklist Builder deleted successfully");
//       fetchData();
//     } catch (err) {
//       const msg = err?.response?.data?.message || "Error while deleting builder";
//       if (err?.response?.status === 409) {
//         Modal.error({
//           title: "Cannot delete template",
//           icon: <HistoryOutlined style={{ color: "#f5222d" }} />,
//           content: (
//             <div style={{ fontSize: 13 }}>
//               <p>{msg}</p>
//               <p style={{ color: "#888", marginTop: 8 }}>
//                 Go to the Checklist menu, filter by this template, delete all
//                 related executions, then come back to delete the template.
//               </p>
//             </div>
//           ),
//           okText: "OK",
//         });
//       } else {
//         message.error(msg);
//       }
//     }
//   };

//   // ── Edit with revision warning ───────────────────────────────────────────
//   const handleEdit = async (record) => {
//     try {
//       const res = await api.get(`${CHECKLIST_BUILDER_URL}/${record.uuid}/has-executions`);
//       if (!res.data.hasExecutions) {
//         navigate(`edit/${record.uuid}`);
//         return;
//       }
//       Modal.confirm({
//         title: "This template has executions",
//         icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
//         content: (
//           <div style={{ fontSize: 13 }}>
//             <p>
//               This template already has execution data recorded against it (
//               <RevisionBadge revisionNo={record.revisionNo || 1} />).
//             </p>
//             <p style={{ marginTop: 8 }}>
//               <strong>Saving your changes will create a new revision.</strong>{" "}
//               The existing execution history is preserved against the current revision.
//             </p>
//           </div>
//         ),
//         okText: "Continue — create new revision",
//         cancelText: "Cancel",
//         onOk: () => navigate(`edit/${record.uuid}`),
//       });
//     } catch {
//       // On error allow through
//       navigate(`edit/${record.uuid}`);
//     }
//   };

//   const applyFilters = () => fetchData(1, size);

//   const resetFilters = () => {
//     setSearch("");
//     setSelectedProduct(null);
//     setDateRange([]);
//     fetchData(1, size, { search: undefined, productId: undefined, fromDate: undefined, toDate: undefined });
//   };

//   const columns = [
//     {
//       title: "Checklist Name",
//       dataIndex: "checklistName",
//       key: "checklistName",
//       sorter: true,
//       sortOrder: sortField === "checklistName" ? sortOrder : null,
//       render: (name, record) => (
//         <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
//           {name}
//           <RevisionBadge revisionNo={record.revisionNo || 1} />
//           {record.isLatest === false && (
//             <span style={{
//               marginLeft: 6, fontSize: 10, color: "#999",
//               background: "#f5f5f5", border: "1px solid #ddd",
//               borderRadius: 3, padding: "1px 5px",
//             }}>
//               Superseded
//             </span>
//           )}
//         </span>
//       ),
//     },
//     {
//       title: "Product Name",
//       dataIndex: "product",
//       key: "product",
//       sorter: true,
//       render: (product, record) => (
//         <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
//           {product?.productName || "-"}
//         </span>
//       ),
//     },
//     {
//       title: "Created At",
//       dataIndex: "createdDate",
//       key: "createdDate",
//       sorter: true,
//       render: (val, record) => (
//         <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
//           {val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"}
//         </span>
//       ),
//     },
//     {
//       title: "Updated At",
//       dataIndex: "updatedDate",
//       key: "updatedDate",
//       sorter: true,
//       render: (val, record) => (
//         <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
//           {val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"}
//         </span>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       width: 140,
//       align: "center",
//       render: (_, record) => (
//         <>
//           {/* View always available for all revisions */}
//           <FolderOpenOutlined
//             style={{ marginRight: 12, cursor: "pointer", opacity: record.isLatest === false ? 0.45 : 1 }}
//             onClick={() => navigate(`view/${record.uuid}`)}
//           />
//           {/* Edit and Delete only for latest revision */}
//           {record.isLatest !== false && canUpdate && (
//             <EditOutlined
//               style={{ marginRight: 12, cursor: "pointer" }}
//               onClick={() => handleEdit(record)}
//             />
//           )}
//           {record.isLatest !== false && canDelete && (
//             <DeleteOutlined
//               style={{ cursor: "pointer" }}
//               onClick={() => deleteData(record.uuid)}
//             />
//           )}
//         </>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <style>{`.row-superseded td { background: #fafafa !important; }`}</style>
//       <div style={{ width: "100%" }}>
//         <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>Checklist Builder</div>
//         </Flex>

//         <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
//           <Input
//             placeholder="Search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{ width: 200 }}
//             allowClear
//           />
//           <TreeSelect
//             value={selectedProduct}
//             onChange={setSelectedProduct}
//             treeData={productList}
//             placeholder="Select product"
//             allowClear
//             style={{ width: 220 }}
//           />
//           <RangePicker value={dateRange} onChange={setDateRange} style={{ width: 260 }} />
//           <Button type="primary" onClick={applyFilters}>Apply</Button>
//           <Button onClick={resetFilters}>Reset</Button>
//           {canCreate && (
//             <Flex flex={1} justify="end">
//               <Button type="primary" onClick={() => navigate("add")}>+ Add</Button>
//             </Flex>
//           )}
//         </Flex>

//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={data}
//           bordered
//           scroll={{ x: "max-content" }}
//           rowClassName={(record) => record.isLatest === false ? "row-superseded" : ""}
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//             pageSizeOptions: ["10", "20", "50", "100"],
//           }}
//           onChange={(pagination, filters, sorter) => {
//             setSortField(sorter.field || sortField);
//             setSortOrder(sorter.order || sortOrder);
//             fetchData(pagination.current, pagination.pageSize, {
//               sort: sorter.field || sortField,
//               desc: sorter.order === "descend",
//             });
//           }}
//         />
//       </div>
//     </Spin>
//   );
// };

// export default ChecklistBuilder;

import { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Flex,
  Input,
  message,
  Spin,
  Table,
  Tag,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  FolderOpenOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { fetchBuilders, deleteBuilder } from "../Service/checklistBuilder";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import usePermission from "../../../../../hooks/usePermission";
import api from "../../../../../BasicComponent/Service/api";
import { CHECKLIST_BUILDER_URL } from "../../../../utils/constService";

const { RangePicker } = DatePicker;

// ── Revision badge ─────────────────────────────────────────────────────────
const RevisionBadge = ({ revisionNo }) => (
  <Tag
    icon={<HistoryOutlined />}
    color={revisionNo > 1 ? "orange" : "default"}
    style={{ fontSize: 10, padding: "0 5px", marginLeft: 4 }}
  >
    Rev {revisionNo}
  </Tag>
);

const ChecklistBuilder = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("CHECKLIST_TEMPLATE");
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");
  const searchTimer = useRef(null);

  const fetchData = async (pageNum = page, pageSize = size, filters = {}) => {
    setLoading(true);
    try {
      const res = await fetchBuilders({
        page: pageNum - 1,
        size: pageSize,
        search: (filters.search ?? search) || undefined,
        fromDate: filters.fromDate ?? (dateRange?.length === 2 ? dateRange[0] : undefined),
        toDate: filters.toDate ?? (dateRange?.length === 2 ? dateRange[1] : undefined),
        sort: filters.sort ?? sortField,
        desc: filters.desc ?? sortOrder === "descend",
      });
      setData(res.data?.content || []);
      setTotal(res.data?.totalElements || 0);
      setPage(pageNum);
      setSize(pageSize);
    } catch {
      message.error("Network error while fetching builders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => fetchData(1, size), 500);
    return () => clearTimeout(searchTimer.current);
  }, [search]);

  // ── Delete with execution guard ──────────────────────────────────────────
  const deleteData = async (uuid) => {
    try {
      await deleteBuilder(uuid);
      message.success("Checklist Builder deleted successfully");
      fetchData();
    } catch (err) {
      const msg = err?.response?.data?.message || "Error while deleting builder";
      if (err?.response?.status === 409) {
        Modal.error({
          title: "Cannot delete template",
          icon: <HistoryOutlined style={{ color: "#f5222d" }} />,
          content: (
            <div style={{ fontSize: 13 }}>
              <p>{msg}</p>
              <p style={{ color: "#888", marginTop: 8 }}>
                Go to the Checklist menu, filter by this template, delete all
                related executions, then come back to delete the template.
              </p>
            </div>
          ),
          okText: "OK",
        });
      } else {
        message.error(msg);
      }
    }
  };

  // ── Edit with revision warning ───────────────────────────────────────────
  const handleEdit = async (record) => {
    try {
      const res = await api.get(`${CHECKLIST_BUILDER_URL}/${record.uuid}/has-executions`);
      if (!res.data.hasExecutions) {
        navigate(`edit/${record.uuid}`);
        return;
      }
      Modal.confirm({
        title: "This template has executions",
        icon: <HistoryOutlined style={{ color: "#fa8c16" }} />,
        content: (
          <div style={{ fontSize: 13 }}>
            <p>
              This template already has execution data recorded against it (
              <RevisionBadge revisionNo={record.revisionNo || 1} />).
            </p>
            <p style={{ marginTop: 8 }}>
              <strong>Saving your changes will create a new revision.</strong>{" "}
              The existing execution history is preserved against the current revision.
            </p>
          </div>
        ),
        okText: "Continue — create new revision",
        cancelText: "Cancel",
        onOk: () => navigate(`edit/${record.uuid}`),
      });
    } catch {
      // On error allow through
      navigate(`edit/${record.uuid}`);
    }
  };

  const applyFilters = () => fetchData(1, size);

  const resetFilters = () => {
    setSearch("");
    setDateRange([]);
    fetchData(1, size, { search: undefined, fromDate: undefined, toDate: undefined });
  };

  const columns = [
    {
      title: "Checklist Name",
      dataIndex: "checklistName",
      key: "checklistName",
      sorter: true,
      sortOrder: sortField === "checklistName" ? sortOrder : null,
      render: (name, record) => (
        <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
          {name}
          <RevisionBadge revisionNo={record.revisionNo || 1} />
          {record.isLatest === false && (
            <span style={{
              marginLeft: 6, fontSize: 10, color: "#999",
              background: "#f5f5f5", border: "1px solid #ddd",
              borderRadius: 3, padding: "1px 5px",
            }}>
              Superseded
            </span>
          )}
        </span>
      ),
    },
    {
      title: "Product Name",
      dataIndex: "product",
      key: "product",
      sorter: true,
      sortOrder: sortField === "product" ? sortOrder : null,
      render: (product, record) => (
        <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
          {product?.productName || "-"}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdDate",
      key: "createdDate",
      sorter: true,
      sortOrder: sortField === "createdDate" ? sortOrder : null,
      render: (val, record) => (
        <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
          {val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"}
        </span>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updatedDate",
      key: "updatedDate",
      sorter: true,
      sortOrder: sortField === "updatedDate" ? sortOrder : null,
      render: (val, record) => (
        <span style={{ opacity: record.isLatest === false ? 0.45 : 1 }}>
          {val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 140,
      align: "center",
      render: (_, record) => (
        <>
          {/* View always available for all revisions */}
          <FolderOpenOutlined
            style={{ marginRight: 12, cursor: "pointer", opacity: record.isLatest === false ? 0.45 : 1 }}
            onClick={() => navigate(`view/${record.uuid}`)}
          />
          {/* Edit and Delete only for latest revision */}
          {record.isLatest !== false && canUpdate && (
            <EditOutlined
              style={{ marginRight: 12, cursor: "pointer" }}
              onClick={() => handleEdit(record)}
            />
          )}
          {record.isLatest !== false && canDelete && (
            <DeleteOutlined
              style={{ cursor: "pointer" }}
              onClick={() => deleteData(record.uuid)}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <style>{`.row-superseded td { background: #fafafa !important; }`}</style>
      <div style={{ width: "100%" }}>
        <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>Checklist Builder</div>
        </Flex>

        <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
          <Input
            placeholder="Search checklist name or product"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 260 }}
            allowClear
          />
          <RangePicker value={dateRange} onChange={setDateRange} style={{ width: 260 }} />
          <Button type="primary" onClick={applyFilters}>Apply</Button>
          <Button onClick={resetFilters}>Reset</Button>
          {canCreate && (
            <Flex flex={1} justify="end">
              <Button type="primary" onClick={() => navigate("add")}>+ Add</Button>
            </Flex>
          )}
        </Flex>

        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          size="small"
          bordered
          scroll={{ x: "max-content" }}
          rowClassName={(record) => record.isLatest === false ? "row-superseded" : ""}
          pagination={{
            current: page,
            pageSize: size,
            total,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          onChange={(pagination, filters, sorter) => {
            setSortField(sorter.field || sortField);
            setSortOrder(sorter.order || sortOrder);
            fetchData(pagination.current, pagination.pageSize, {
              sort: sorter.field || sortField,
              desc: sorter.order === "descend",
            });
          }}
        />
      </div>
    </Spin>
  );
};

export default ChecklistBuilder;